/** @jsx h */
import FilterActive from './FilterActive';
import { Fragment } from 'preact';

const FilterActiveContainer = ({
  facetsActive,
  triggerAjaxSubmit,
  resetFilters,
}) => {
  return (
    <Fragment>
      {facetsActive && (
        <div className="search-form__active-filters">
          <FilterActive
            facetsActive={facetsActive}
            triggerAjaxSubmit={triggerAjaxSubmit}
            resetFilters={resetFilters}
          />
        </div>
      )}
    </Fragment>
  );
};

export default FilterActiveContainer;
